import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function splitCamelCase(str: string) {
    return str.replace(/([a-z])([A-Z])/g, "$1 $2");
}

function toTitleCase(str: string) {
    return splitCamelCase(str)
        .replace(/-/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
}

export const DynamicTitle = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // SPECIAL CASE for login
        if (pathname === "/" || pathname === "/login") {
            document.title = "Login - Waivera";
            return;
        }

        if (pathname.startsWith("/profile/user")) { 
            document.title = "User Profile - Waivera"
            return;
        }

        const fullTitleOverrides: Record<string, string> = {
            "/drive/employee-files": "Participant Files - Waiera",
            "/drive/caseFileDrive": "Participant Files - Waiera",
            "/drive/personal": "Participant Files - Waiera",
        };

        if (fullTitleOverrides[pathname]) {
            document.title = fullTitleOverrides[pathname];
            return;
        }

        const titleOverrides: Record<string, string> = {
            "/termsservices": "Terms of Service",
            "/privacypolicy": "Privacy Policy",
            "/legal/sign/tos": "Terms of Service",
            "/legal/sign/data-agreement": "Data Processing Agreement",
            "/legal/sign/security-compliance-terms": "Security & Compliance Terms",
            "/legal/sign/electronic-signature-consent": "Electronic Signature Consent",
        };

        const parts = pathname.split("/").filter(Boolean);

        // Convert URL segments
        let formattedParts = parts.map(toTitleCase);

        // SPECIAL CASE: Drive CaseFileDrive → remove duplicate "Drive"
        if (formattedParts[0] === "Drive" && formattedParts[1]?.endsWith("Drive")) {
            formattedParts[1] = formattedParts[1].replace(/Drive$/, "").trim();
        }

        // Join words
        const rawTitle = titleOverrides[pathname] ?? (formattedParts.length ? formattedParts.join(" ") : "Waivera");

        // Remove notification count like "(3)"
        const cleaned = rawTitle.replace(/^\(\d+\)\s*/, "");

        document.title = `${cleaned} - Waivera`;
    }, [pathname]);

    return null;
};
